module.exports = __webpack_public_path__ + "static/media/project1.93ec16c0.jpg";